export const isStandaloneMode = () => {
  if ('standalone' in window.navigator && window.navigator.standalone) {
    return true;
  }

  return window.matchMedia('(display-mode: standalone)').matches;
}
